// Usuarios: gestión de usuarios de la organización. Antes era una pestaña de
// Configuración; ahora es una sección propia del menú principal (entre Reportes
// y Configuración). Reutiliza el mismo panel (UsersPanel) definido en Settings.
import type { JSX } from "react";
import { UsersPanel } from "./Settings.tsx";

export function Users(): JSX.Element {
  return (
    <div className="space-y-4">
      <h1 className="page-title">Usuarios</h1>
      <UsersPanel />
    </div>
  );
}
